import * as THREE from 'three';
import * as CANNON from 'cannon-es';
import PhysVisUtil from "@/PhysVisUtil";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import CarEngine from './CarEngine';
import GameSceneRace from './GameSceneRace';

class Car {
	
	vehicle: CANNON.RaycastVehicle = null!;
	
	engine: CarEngine;
	
	sceneRootObject: THREE.Object3D;

	physVisUtil: any;
	
	wheelMaterial: CANNON.Material;

	world: CANNON.World;

	groundMaterial: CANNON.Material;
	roadMaterial: CANNON.Material;
	frameMaterial: CANNON.Material;
	
	frameBody: CANNON.Body = null!;
	wheelLFBody: CANNON.Body = null!;	
	wheelRFBody: CANNON.Body = null!;	
	wheelLBBody: CANNON.Body = null!;	
	wheelRBBody: CANNON.Body = null!;	

	// бразды управления для режима FCS
	constraintLF: CANNON.HingeConstraint = null!;
	constraintRF: CANNON.HingeConstraint = null!;
	constraintLB: CANNON.HingeConstraint = null!;
	constraintRB: CANNON.HingeConstraint = null!;


	// значения скорости и угла поворота колёс
    forwardVelocity = 0;
    rightVelocity = 0;
    
    // приращения скорости и угла поворота колёс
    dForwardVelocity = 0;
    
    // нажатость кнопок руля
    steeringLeft = false;
    steeringRight = false;
    
    wheelGround: CANNON.ContactMaterial = null!;
    wheelRoad: CANNON.ContactMaterial = null!;
    frameGround: CANNON.ContactMaterial = null!;
    
    visibleObjectGame: THREE.Object3D;  // отображение машины, режим игры (обычный)
    visibleObjectPhys: THREE.Object3D;  // отображение машины, режим показа физического представления
    showModePhys = false; // какой из двух режимов отображения активен (переключаем кнопкой)  

    frameMesh = new THREE.Mesh()

    wheelLFMesh = new THREE.Group()
    wheelRFMesh = new THREE.Group()
    wheelLBMesh = new THREE.Group()
    wheelRBMesh = new THREE.Group()

	wheelBodies: CANNON.Body[] = [];

//	maxSteerVal = 0.5;
//	maxForce = 2000;
//	brakeForce = 1000000;
//	
	
	prevPosition: CANNON.Vec3;
	
	fullDistance = 0;
	
	wheelRadius = 0.4;
	
	//roadAmplitudeX;
	//noise2D;
	
	autoSteering = false;
	
	braked = false;  // на тормозе или нет

	gameSceneRace: GameSceneRace;

	constructor(sceneRootObject: THREE.Object3D, world: CANNON.World, groundMaterial: CANNON.Material, roadMaterial: CANNON.Material,
				initX: number, initY: number, initZ: number, gameSceneRace: GameSceneRace) {

		this.gameSceneRace = gameSceneRace; 

		//this.roadAmplitudeX = roadAmplitudeX;
		//this.noise2D = noise2D;

		this.sceneRootObject = sceneRootObject;
		
		this.visibleObjectGame = new THREE.Object3D();
		sceneRootObject.add(this.visibleObjectGame);
		
		this.visibleObjectPhys = new THREE.Object3D();
		
		this.world = world;		

		this.groundMaterial = groundMaterial;
		this.roadMaterial = roadMaterial;
		
		// взаимодействие колёс с поверхностью		
		this.wheelMaterial = new CANNON.Material('wheel');

		this.frameMaterial = new CANNON.Material('frame');
		
		this.physVisUtil = new PhysVisUtil(); 


		const options = {
			radius: this.wheelRadius,
			directionLocal: new CANNON.Vec3(0, -1, 0),
//			suspensionStiffness: 30,
			suspensionStiffness: 45,  // жёсткость подвески
//			suspensionStiffness: 30,  // жёсткость подвески
///			suspensionRestLength: 0.3,
			suspensionRestLength: 0.2, // ход подвески?
			// frictionSlip - трение скольжения, влияет на заносы и управляемость; чем больше значение, тем машина управляемее
///			frictionSlip: 10, // - очень хорошие шины + идеальный асфальт
//			frictionSlip: 0.5, // - каменная поверхность, на ней чуть что - будет сносить
			frictionSlip: 4,
//			frictionSlip: 1.4,
//			dampingRelaxation: 2.3,
			dampingRelaxation: 10,
//			dampingRelaxation: 100,
//			dampingCompression: 4.4,
			dampingCompression: 3,
//			dampingCompression: 1,
//			dampingCompression: 2,
//			maxSuspensionForce: 100000,
///			maxSuspensionForce: 1000000,
//			maxSuspensionForce: 1000,
			maxSuspensionForce: 10000000,
			// rollInfluence - чем больше значение, тем сильнее машину опрокидывает на поворотах
///			rollInfluence:  0.01,
			rollInfluence:  0.2,
//			rollInfluence:  5,
//			rollInfluence:  0.05,
			axleLocal: new CANNON.Vec3(-1, 0, 0),
			chassisConnectionPointLocal: new CANNON.Vec3(1, 1, 0),
///			maxSuspensionTravel: 0.3,  // скорее всего, это ход
			maxSuspensionTravel: 0.2,
//			customSlidingRotationalSpeed: -30,
			customSlidingRotationalSpeed: 3,
//			customSlidingRotationalSpeed: 0,
//			customSlidingRotationalSpeed: 0,
			useCustomSlidingRotationalSpeed: true
		};

//        this.frameBody = new CANNON.Body({ mass: 150 })
        this.frameBody = new CANNON.Body({ mass: 2000 })
//        this.frameBody = new CANNON.Body({ mass: 3000 })
///        this.frameBody = new CANNON.Body({ mass: 5000 })
//			this.frameBody = new CANNON.Body({ mass: 7500 })
//        this.frameBody = new CANNON.Body({ mass: 50 })

		const centerMassY = 0.5;
//		const centerMassY = -0.15;

		const sphereRadius = 0.1;
//		const sphereRadius = 0.2;

        this.frameBody.addShape(
            new CANNON.Sphere(sphereRadius),
            new CANNON.Vec3(0, 0.8 + centerMassY, 0.4)
        )
        this.frameBody.addShape(
            new CANNON.Sphere(sphereRadius),
            new CANNON.Vec3(0, -0.1 + centerMassY, -1.3)
        )
        this.frameBody.addShape(
            new CANNON.Sphere(sphereRadius),
            new CANNON.Vec3(0, -0.1 + centerMassY, 1.3)
        )
        this.frameBody.addShape(
			new CANNON.Sphere(sphereRadius), 
			new CANNON.Vec3(1, -0.1 + centerMassY, 0)
		)
        this.frameBody.addShape(
            new CANNON.Sphere(sphereRadius),
            new CANNON.Vec3(-1, -0.1 + centerMassY, 0)
        )

        
        this.frameBody.position.set(initX, initY, initZ);
		this.physVisUtil.addVisual(this.visibleObjectPhys, this.frameBody, "chassis", "", 0);
        
        this.frameBody.angularVelocity.set(0, 0, 0);
        
        this.prevPosition = new CANNON.Vec3();
        this.prevPosition.copy(this.frameBody.position); 

		// contactMaterial'ы не работают в cannon-es для raycastvehicle
		
			this.frameGround = new CANNON.ContactMaterial(this.frameMaterial, this.groundMaterial, {
				friction: 50,
				restitution: 0,
				contactEquationStiffness: 1000000,
				contactEquationRelaxation: 3,
				//frictionEquationStiffness: 10,
				//frictionEquationRelaxation: 5,
			});
			
			// режим raycastvehicle
			this.vehicle = new CANNON.RaycastVehicle({
				chassisBody: this.frameBody,
			});

//			console.log("this.vehicle.indexUpAxis = " + this.vehicle.indexUpAxis);
//			console.log("this.vehicle.indexRightAxis = " + this.vehicle.indexRightAxis);
//			console.log("this.vehicle.indexForwardAxis = " + this.vehicle.indexForwardAxis);
			this.vehicle.indexUpAxis = 1;
			this.vehicle.indexRightAxis = 0; 
			this.vehicle.indexForwardAxis = 2;

//			const wheelY = 0.3;
			///const wheelY = 0.3 - options.suspensionRestLength;
			const wheelY = 0.3 - options.maxSuspensionTravel;

			options.chassisConnectionPointLocal.set(1, wheelY, -1);
			this.vehicle.addWheel(options);

			options.chassisConnectionPointLocal.set(-1, wheelY, -1);
			this.vehicle.addWheel(options);

			options.chassisConnectionPointLocal.set(1, wheelY, 1);
			this.vehicle.addWheel(options);

			options.chassisConnectionPointLocal.set(-1, wheelY, 1);
			this.vehicle.addWheel(options);

			this.vehicle.addToWorld(this.world);
		
			for(let i = 0; i < this.vehicle.wheelInfos.length; i++) {
			
//				console.log("колесо " + i);			
			
				const wheel = this.vehicle.wheelInfos[i];
				///const wheelShape = new CANNON.Cylinder(wheel.radius, wheel.radius, wheel.radius / 2, 20);
				const wheelShape = new CANNON.Sphere(wheel.radius);
//                const wheelBody = new CANNON.Body({ mass: 1});
                const wheelBody = new CANNON.Body({ mass: 1, material: this.wheelMaterial });
                
///				wheelBody.type = CANNON.Body.KINEMATIC
///				wheelBody.collisionFilterGroup = 0 // turn off collisions
                
                const q = new CANNON.Quaternion();
                q.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), Math.PI / 2);
///                q.setFromAxisAngle(new CANNON.Vec3(0, 0, 1), -Math.PI / 2);
//                wheelBody.addShape(cylinderShape, new CANNON.Vec3(), q);
//                wheelBody.addShape(wheelShape, new CANNON.Vec3(), q);
                wheelBody.addShape(wheelShape);
                this.wheelBodies.push(wheelBody);
                
				this.world.addBody(wheelBody);                
                
                //demo.addVisual(wheelBody);
				this.physVisUtil.addVisual(this.visibleObjectPhys, wheelBody, "wheel", "");
			}

			this.wheelLFBody = this.wheelBodies[0]; 
			this.wheelRFBody = this.wheelBodies[1]; 
			this.wheelLBBody = this.wheelBodies[2]; 
			this.wheelRBBody = this.wheelBodies[3]; 
			

///		this.world.addContactMaterial(this.wheelGround);
///		this.world.addContactMaterial(this.wheelRoad);
		this.world.addContactMaterial(this.frameGround);
		
		// загружаем 3D-модель
        const pipesMaterial = new THREE.MeshStandardMaterial()
        pipesMaterial.color = new THREE.Color('#ffffff')
//        pipesMaterial.refractionRatio = 0
        pipesMaterial.roughness = 0.2
        pipesMaterial.metalness = 1
		
        const loader = new GLTFLoader()
        loader.load('models/cars/frame.glb', (gltf) => {
                this.frameMesh = gltf.scene.children[0] as THREE.Mesh
                this.frameMesh.material = pipesMaterial
                this.frameMesh.castShadow = true
                this.visibleObjectGame.add(this.frameMesh)

                loader.load(
                    'models/cars/tyre.glb',
                    (gltf) => {
                        this.wheelLFMesh = gltf.scene
                        this.wheelLFMesh.children[0].castShadow = true
                        this.wheelRFMesh = this.wheelLFMesh.clone()
                        this.wheelLBMesh = this.wheelLFMesh.clone()
                        this.wheelRBMesh = this.wheelLFMesh.clone()
                        this.wheelLFMesh.scale.setScalar(0.87)
                        this.wheelRFMesh.scale.setScalar(0.87)
                        this.visibleObjectGame.add(this.wheelLFMesh)
                        this.visibleObjectGame.add(this.wheelRFMesh)
                        this.visibleObjectGame.add(this.wheelLBMesh)
                        this.visibleObjectGame.add(this.wheelRBMesh)
						this.wheelLFMesh.castShadow = true
						this.wheelRFMesh.castShadow = true
						this.wheelLBMesh.castShadow = true
						this.wheelRBMesh.castShadow = true
                    },
                    (xhr) => {
                        console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
                    },
                    (error) => {
                        console.log(error)
                    }
                )
            },
            (xhr) => {
                console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
            },
            (error) => {
                console.log(error)
            }
        )
		
		this.engine = new CarEngine(this, this.vehicle, this.gameSceneRace);

	}
	/////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////
	getPhysBodyPosition() {
		return this.frameBody.position;
	}
	getPhysBodyQuaternion() {
		return this.frameBody.quaternion;
	}
	getPhysBodyVelocity() {
		return this.frameBody.velocity;
	}
	/////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////
	control(eventVal: string) {
		// управление машиной
		
		if (this.gameSceneRace.isPlayerPlace) {
			// в режиме владения игрока машиной не управляем
			return;
		}
		
		this.engine.playerControl(eventVal);

          switch (eventVal) {
/*			  
            case 'u+':  // forward: press 
				this.dForwardVelocity = 1.25;
				break;

            case 'd+':  // backward: press
				this.dForwardVelocity = -1.25;
				break;
*/				

            case 'l+':
				//this.dRightVelocity = -0.1;
				this.steeringLeft = true;
				break;

            case 'r+':
				//this.dRightVelocity = 0.1;
				this.steeringRight = true;
				break;

/*			  
            case 'u-':
              this.dForwardVelocity = 0;
              this.forwardVelocity = 0;
              break

            case 'd-':
              this.dForwardVelocity = 0;
              this.forwardVelocity = 0;
              break
*/
            case 'l-':
				this.steeringLeft = false;
				break;

            case 'r-':
				this.steeringRight = false;
				break;
          }
		
	}
	/////////////////////////////////////////////////////////
	updateVisuals() {
		this.physVisUtil.updateVisuals();
	}
	/////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////
	animate() {
		// (сразу после world.step)


		const euler:CANNON.Vec3 = new CANNON.Vec3();
		this.frameBody.quaternion.toEuler(euler);
				
		euler.normalize();
			
		let st = document.getElementById("carVector");
		if (st != null) {
			st.innerHTML = ("" + euler).replaceAll(",", "<br>");
		}

		st = document.getElementById("carForce");
		if (st != null) {
			st.innerHTML = ("" + this.frameBody.force).replaceAll(",", "<br>");
		}
		
		// вместо postStep перенёс сюда
			for (let i = 0; i < this.vehicle.wheelInfos.length; i++) {
				this.vehicle.updateWheelTransform(i);
				const t = this.vehicle.wheelInfos[i].worldTransform;
				this.wheelBodies[i].position.copy(t.position);
				this.wheelBodies[i].quaternion.copy(t.quaternion);
			}
		
		
		
		// текущую скорость определяем как разницу позиций этой и предыдущей итераций,
		// делённую на время между итерациями (1/60 сек)
		const iterationDistance: number = this.prevPosition.distanceTo(this.frameBody.position);  // метры
//		const iterationDistance: number = this.prevPosition.z - this.frameBody.position.z;  // метры
		
		this.fullDistance += iterationDistance; 
		

//		console.log("prevPosition = " + this.prevPosition);
//		console.log("position = " + iterationDistance);
		
//		console.log("iterationDistance = " + iterationDistance);
//		console.log("fullDistance = " + this.fullDistance);
		
		const speed: number = iterationDistance * 60;  // что = / (1 / 60); м/с

//		console.log("speed = " + speed);
		
		st = document.getElementById("carSpeed");
		if (st != null) {
			st.innerHTML = "" + (Math.round(speed * 3.6 * 10) / 10) + " км/ч";
		}
		
		this.engine.actionStep(speed);  // из скорости определяем текущий RPM, сопротивление воздуха, трение качения

		/*
		st = document.getElementById("carPositionPrev");
		if (st != null) {
			st.innerHTML = ("" + this.prevPosition).replaceAll(',', "<br>");
//			st.innerHTML = ("" + this.prevPosition.z).replaceAll(',', "<br>");
		}
		st = document.getElementById("carPositionCur");
		if (st != null) {
			st.innerHTML = ("" + this.frameBody.position).replaceAll(',', "<br>");
//			st.innerHTML = ("" + this.frameBody.position.z).replaceAll(',', "<br>");
		}
		
		st = document.getElementById("iterationDistance");
		if (st != null) {
			st.innerHTML = "" + iterationDistance;
		}
		*/

		this.prevPosition.copy(this.frameBody.position);
		


        this.frameMesh.position.copy(this.frameBody.position);
        this.frameMesh.quaternion.copy(this.frameBody.quaternion);

        this.wheelLFMesh.position.copy(this.wheelLFBody.position);
        this.wheelLFMesh.quaternion.copy(this.wheelLFBody.quaternion);

        this.wheelRFMesh.position.copy(this.wheelRFBody.position);
        this.wheelRFMesh.quaternion.copy(this.wheelRFBody.quaternion);

        this.wheelLBMesh.position.copy(this.wheelLBBody.position);
        this.wheelLBMesh.quaternion.copy(this.wheelLBBody.quaternion);

        this.wheelRBMesh.position.copy(this.wheelRBBody.position);
        this.wheelRBMesh.quaternion.copy(this.wheelRBBody.quaternion);
		
		
		if (this.steeringRight && !this.steeringLeft) {
			if (this.rightVelocity >= -0.5) {
				this.rightVelocity -= 0.005; 
///				this.rightVelocity -= 0.0005; 
			}
		}

		if (this.steeringLeft && !this.steeringRight) {
			if (this.rightVelocity <= 0.5) {
				this.rightVelocity += 0.005;
///				this.rightVelocity += 0.0005;
			}	 
		}

		if (!this.steeringLeft && !this.steeringRight) {
			this.rightVelocity = this.lerp(this.rightVelocity, 0, 0.9);
			
			if (Math.abs(this.rightVelocity) < 0.0125) {
				this.rightVelocity = 0;
			}
			
		}

			this.vehicle.setSteeringValue(this.rightVelocity, 0);
			this.vehicle.setSteeringValue(this.rightVelocity, 1);
	
		
		st = document.getElementById("steering");
		if (st != null) {
			st.innerHTML = "" + this.rightVelocity;
		}
		
		st = document.getElementById("positionX");
		if (st != null) {
			st.innerHTML = "" + (Math.round(this.getPhysBodyPosition().x * 10) / 10);
		}
		st = document.getElementById("positionY");
		if (st != null) {
			st.innerHTML = "" + (Math.round(this.getPhysBodyPosition().y * 10) / 10);
		}
		st = document.getElementById("positionZ");
		if (st != null) {
			st.innerHTML = "" + (Math.round(this.getPhysBodyPosition().z * 10) / 10);
		}
		
	}
	/////////////////////////////////////////////////////////
    lerp = (x: number, y: number, a: number): number => {
        return (1 - a) * x + a * y
    }
	/////////////////////////////////////////////////////////
	changeShowMode() {
		this.showModePhys = !this.showModePhys;
		
		if (this.showModePhys) {
			this.sceneRootObject.remove(this.visibleObjectGame);
			this.sceneRootObject.add(this.visibleObjectPhys);
		} else {
			this.sceneRootObject.remove(this.visibleObjectPhys);
			this.sceneRootObject.add(this.visibleObjectGame);
		}
		
	}
	/////////////////////////////////////////////////////////
	brakeOn(brakeForce: number) {
		this.braked = true;



			const mult = 5;
			
			this.vehicle.setBrake(brakeForce * mult, 0);
			this.vehicle.setBrake(brakeForce * mult, 1);
			this.vehicle.setBrake(brakeForce * mult, 2);
			this.vehicle.setBrake(brakeForce * mult, 3);
			
	}
	brakeOff() {
		this.braked = false;

			this.vehicle.setBrake(0, 0);
			this.vehicle.setBrake(0, 1);
			this.vehicle.setBrake(0, 2);
			this.vehicle.setBrake(0, 3);
	}
	/////////////////////////////////////////////////////////
	getWheelRadius() {
		return this.wheelRadius;
	}
	/////////////////////////////////////////////////////////
	switchAutoSteering(autoSteeringChecked: boolean) {
		this.engine.switchAutoSteering(autoSteeringChecked);
	}
	/////////////////////////////////////////////////////////
	updateWheels() {
		// для каждого колеса определяем поверхность, над которым оно находится, и изменяем свойства колеса в зависимости от поверхности
		// - поверхность определяем упрощённо, просто по вертикали; а для астероида будет по прямой к центру
		
		let str = '';
		
		const car: CANNON.RaycastVehicle = this.vehicle; 
		const wheels = car.wheelInfos;
		
		// множители моментов ведущих колёс
		let multMomentLeft = 1;
		let multMomentRight = 1;
		
		for (let i = 0; i < 4; i++) {
			
			const position = wheels[i].chassisConnectionPointWorld; 
			
			const road = this.gameSceneRace.getRoad(position.z);
			const obj = this.gameSceneRace.getTerrainPoint(position.x, position.z);
			
			str += "" + i + ": ";
			
			let frictionSlip;

			let multMoment = 1;
			
			if ((position.x >= road.roadLeft) && (position.x <= road.roadRight)) {
				frictionSlip = 10;
				str += ', дорога';
			} else if (obj.ground > obj.rock) {
				frictionSlip = 3;
				multMoment = 0.75;
				str += ', земля';
			} else {
///				frictionSlip = 0.25;
				frictionSlip = 1;
				multMoment = 0.5;
				str += ', скала';
			}
			
			
			const inWater = (Math.max(obj.ground, obj.rock) <= this.gameSceneRace.WATER_HEIGHT); 
			
			if (inWater) {
				str += ", в воде"
				
				multMoment *= 0.5;
				
				frictionSlip *= 0.75;
				
			}

			wheels[i].frictionSlip = frictionSlip; 

			if (i == 2) {
				multMomentLeft = multMoment;
			}
			if (i == 3) {
				multMomentRight = multMoment;
			}
			
			str += "<br>";
		}
		
		this.engine.multMomentLeft = multMomentLeft; 
		this.engine.multMomentRight = multMomentRight; 
		
		
		const p = document.getElementById('carWheels');
		if (p != null) {
			p.innerHTML = str;
		} 
		
		
		
		
		
	}
	/////////////////////////////////////////////////////////
	
}
export default Car;